export default [
  {
    OPT_CLAS_CD: 'SOP00004',
    OPT_ITEM_CD: '00000255',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 1,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: '케냐AA 니에리 워시드',
    PRESET_NM_KO: '케냐AA 니에리 워시드',
    PRESET_NM_EN: '케냐AA 니에리 워시드',
    PRESET_NM_JP: '케냐AA 니에리 워시드',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 500,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00005',
    OPT_ITEM_CD: '00000266',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 1,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: '자메이카 블루마운틴',
    PRESET_NM_KO: '자메이카 블루마운틴',
    PRESET_NM_EN: '자메이카 블루마운틴',
    PRESET_NM_JP: '자메이카 블루마운틴',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 1000,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00004',
    OPT_ITEM_CD: '00000256',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 2,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: '케냐AA 니에리 워시드2',
    PRESET_NM_KO: '케냐AA 니에리 워시드2',
    PRESET_NM_EN: '케냐AA 니에리 워시드2',
    PRESET_NM_JP: '케냐AA 니에리 워시드2',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 400,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00005',
    OPT_ITEM_CD: '00000267',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 2,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: '자메이카 블루마운틴2',
    PRESET_NM_KO: '자메이카 블루마운틴2',
    PRESET_NM_EN: '자메이카 블루마운틴2',
    PRESET_NM_JP: '자메이카 블루마운틴2',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 900,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00004',
    OPT_ITEM_CD: '00000257',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 3,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: '케냐AA 니에리 워시드3',
    PRESET_NM_KO: '케냐AA 니에리 워시드3',
    PRESET_NM_EN: '케냐AA 니에리 워시드3',
    PRESET_NM_JP: '케냐AA 니에리 워시드3',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 300,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00005',
    OPT_ITEM_CD: '00000268',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 3,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: '자메이카 블루마운틴3',
    PRESET_NM_KO: '자메이카 블루마운틴3',
    PRESET_NM_EN: '자메이카 블루마운틴3',
    PRESET_NM_JP: '자메이카 블루마운틴3',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 800,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00004',
    OPT_ITEM_CD: '00000258',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 4,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: '케냐AA 니에리 워시드4',
    PRESET_NM_KO: '케냐AA 니에리 워시드4',
    PRESET_NM_EN: '케냐AA 니에리 워시드4',
    PRESET_NM_JP: '케냐AA 니에리 워시드4',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 200,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00005',
    OPT_ITEM_CD: '00000269',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 4,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: '자메이카 블루마운틴4',
    PRESET_NM_KO: '자메이카 블루마운틴4',
    PRESET_NM_EN: '자메이카 블루마운틴4',
    PRESET_NM_JP: '자메이카 블루마운틴4',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 700,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_ITEM_CD: '00000135',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122375278',
    OPT_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/01.img_Bananawaffles.png'),
    ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/01.img_Bananawaffles.png'),
    SALES_QTY: 0,
    PRESET_NM: '바나나 와플',
    PRESET_NM_KO: '바나나 와플',
    PRESET_NM_EN: 'Banana Waffles',
    PRESET_NM_JP: 'バナナワッフル',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 4500,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_ITEM_CD: '00000136',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122375278',
    OPT_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/02.img_Breakfastsandwich.png'),
    ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/02.img_Breakfastsandwich.png'),
    SALES_QTY: 0,
    PRESET_NM: '브렉퍼스트 샌드위치',
    PRESET_NM_KO: '브렉퍼스트 샌드위치',
    PRESET_NM_EN: 'Breakfast Sandwich',
    PRESET_NM_JP: '朝食サンドイッチ',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 4200,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_ITEM_CD: '00000137',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122375278',
    OPT_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/03.img_Chocolatemoussecake.png'),
    ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/03.img_Chocolatemoussecake.png'),
    SALES_QTY: 0,
    PRESET_NM: '초콜렛 무스케이크',
    PRESET_NM_KO: '초콜렛 무스케이크',
    PRESET_NM_EN: 'Chocolate Mousse Cake',
    PRESET_NM_JP: 'チョコレートムースケーキ',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 4500,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_ITEM_CD: '00000138',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122375279',
    OPT_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/04.img_Chocolatemuffin.png'),
    ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/04.img_Chocolatemuffin.png'),
    SALES_QTY: 0,
    PRESET_NM: '초코머핀',
    PRESET_NM_KO: '초코머핀',
    PRESET_NM_EN: 'Chocolate Muffin',
    PRESET_NM_JP: 'チョコレートマフィン',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 3200,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_ITEM_CD: '00000139',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122375280',
    OPT_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/05.img_Donut.png'),
    ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/05.img_Donut.png'),
    SALES_QTY: 0,
    PRESET_NM: '도너츠',
    PRESET_NM_KO: '도너츠',
    PRESET_NM_EN: 'Donut',
    PRESET_NM_JP: 'ドーナツ',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 2400,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_ITEM_CD: '00000140',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122375281',
    OPT_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/06.img_JambonBeurre.png'),
    ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/06.img_JambonBeurre.png'),
    SALES_QTY: 0,
    PRESET_NM: '잠봉뵈르 베이글',
    PRESET_NM_KO: '잠봉뵈르 베이글',
    PRESET_NM_EN: 'Jambon Beurre',
    PRESET_NM_JP: 'ジャンボン ブール',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 4500,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_ITEM_CD: '00000141',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122375282',
    OPT_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/07.img_Scone.png'),
    ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/07.img_Scone.png'),
    SALES_QTY: 0,
    PRESET_NM: '바닐라스콘',
    PRESET_NM_KO: '바닐라스콘',
    PRESET_NM_EN: 'Scone',
    PRESET_NM_JP: 'スコーン',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 3200,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_ITEM_CD: '00000142',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122375283',
    OPT_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/08.img_StrawberryCake.png'),
    ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/08.img_StrawberryCake.png'),
    SALES_QTY: 0,
    PRESET_NM: '딸기 조각케이크',
    PRESET_NM_KO: '딸기 조각케이크',
    PRESET_NM_EN: 'Strawberry Cake',
    PRESET_NM_JP: 'ストロベリーケーキ',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 4800,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00002',
    OPT_ITEM_CD: '00000147',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: 'S 사이즈',
    PRESET_NM_KO: 'S 사이즈',
    PRESET_NM_EN: 'S',
    PRESET_NM_JP: 'Sサイズ',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '002',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 0,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 0,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00002',
    OPT_ITEM_CD: '00000148',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: 'M 사이즈 ',
    PRESET_NM_KO: 'M 사이즈 ',
    PRESET_NM_EN: 'M',
    PRESET_NM_JP: 'Mサイズ',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '002',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 300,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00002',
    OPT_ITEM_CD: '00000149',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: 'L 사이즈',
    PRESET_NM_KO: 'L 사이즈',
    PRESET_NM_EN: 'L',
    PRESET_NM_JP: 'Lサイズ',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '002',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 500,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00006',
    OPT_ITEM_CD: '00000259',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122376081',
    OPT_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376081_1_v0001.png',
    ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376081_1_v0001.png',
    SALES_QTY: 0,
    PRESET_NM: '매장컵',
    PRESET_NM_KO: '매장컵',
    PRESET_NM_EN: '매장컵',
    PRESET_NM_JP: '매장컵',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 0,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 0,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00006',
    OPT_ITEM_CD: '00000260',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122376082',
    OPT_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376082_1_v0001.png',
    ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376082_1_v0001.png',
    SALES_QTY: 0,
    PRESET_NM: '일회용컵',
    PRESET_NM_KO: '일회용컵',
    PRESET_NM_EN: '일회용컵',
    PRESET_NM_JP: '일회용컵',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 100,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00006',
    OPT_ITEM_CD: '00000261',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122376083',
    OPT_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376083_1_v0001.png',
    ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376083_1_v0001.png',
    SALES_QTY: 0,
    PRESET_NM: '개인컵',
    PRESET_NM_KO: '개인컵',
    PRESET_NM_EN: '개인컵',
    PRESET_NM_JP: '개인컵',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 0,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 0,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00007',
    OPT_ITEM_CD: '00000262',
    OPT_ITEM_TYPE: '1',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122376084',
    OPT_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376084_1_v0001.png',
    ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376084_1_v0001.png',
    SALES_QTY: 0,
    PRESET_NM: '휘핑크림',
    PRESET_NM_KO: '휘핑크림',
    PRESET_NM_EN: '휘핑크림',
    PRESET_NM_JP: '휘핑크림',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 300,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00007',
    OPT_ITEM_CD: '00000263',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122376085',
    OPT_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376085_1_v0001.png',
    ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376085_1_v0001.png',
    SALES_QTY: 0,
    PRESET_NM: '초코칩',
    PRESET_NM_KO: '초코칩',
    PRESET_NM_EN: '초코칩',
    PRESET_NM_JP: '초코칩',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 400,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00007',
    OPT_ITEM_CD: '00000264',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122376086',
    OPT_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376086_1_v0001.png',
    ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376086_1_v0001.png',
    SALES_QTY: 0,
    PRESET_NM: '달고나',
    PRESET_NM_KO: '달고나',
    PRESET_NM_EN: '달고나',
    PRESET_NM_JP: '달고나',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 200,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'SOP00007',
    OPT_ITEM_CD: '00000265',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 999,
    OPT_ITEM_IMG_FILE_ID: '2122376087',
    OPT_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376087_1_v0001.png',
    ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376087_1_v0001.png',
    SALES_QTY: 0,
    PRESET_NM: '인절미 그래놀라',
    PRESET_NM_KO: '인절미 그래놀라',
    PRESET_NM_EN: '인절미 그래놀라',
    PRESET_NM_JP: '인절미 그래놀라',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '001',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 900,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
];
